import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

import {TreeNode} from '../../../shared/ui';
import {TreeItem} from '../../../shared/ui/tree-multi-select/treeview.component';
import {FieldReviewRow, FieldReviewState} from '../../template-management.interfaces';

@Component({
  selector: 'gp-placeholders-tab',
  templateUrl: './placeholders-tab.component.html',
  styleUrls: ['./placeholders-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceholdersTabComponent {

  @Input()
  public state: FieldReviewState = 'idle';

  @Input()
  public rows: FieldReviewRow[] = [];

  @Input()
  public fieldTree: Array<TreeNode<TreeItem>> = [];

  @Input()
  public canMatch = false;

  @Output()
  public apply = new EventEmitter<FieldReviewRow[]>();

  @Output()
  public rowsChange = new EventEmitter<FieldReviewRow[]>();

  @Output()
  public locate = new EventEmitter<string>();

  @Output()
  public matchWithAi = new EventEmitter<void>();

  @Output()
  public refresh = new EventEmitter<void>();

  public get approvedRows(): FieldReviewRow[] {
    return (this.rows ?? []).filter((row) => row.selected && row.fields.length > 0);
  }
}
